module.exports = __webpack_public_path__ + "static/media/seminar_2.efa89ec0.pdf";